<template>
  <div class="container">
    <router-view :key="$route.fullPath"/>

    <div class="upload-content">
      <!-- 顶部栏 -->
      <div class="header">
        <div class="title">{{ questionId ? '记录详情' : '上传图片' }}</div>
        <div class="history"
             @click="jumpHistory()"
             v-if="!questionId"
             :class="{ 'disabled-style': loading_answer }"
             :disabled="loading_answer">历史记录</div>
      </div>

      <div class="sub-title">（仅支持医院检验单，如验血单等）</div>

      <div class="img_box">
<!--        <img-->
<!--          v-if="data.attachId"-->
<!--          :src="data.url"-->
<!--          style="height: 8rem;object-fit: cover;"-->
<!--        />-->
        <van-image
            width="8rem"
            height="8rem"
            fit="cover"
            :src="data.url"
            v-if="data.attachId"
            @click="sceneImg(data.url)"
        />
        <van-uploader
            v-else
            v-model="fileList"
            :after-read="onAfterRead"
            accept="image/*"
            :max-size="20 * 1024 * 1024"
            :max-count="1"
            preview-size="8rem"
            @oversize="onOversize"
            lazy-load
            :before-delete="beforeDelete">
          <template #default>
            <div class="upload-box">
              <van-icon name="photograph" class="upload-icon" />
            </div>
          </template>
        </van-uploader>

      </div>

      <!-- AI识别按钮 -->
      <van-button
          type="primary"
          block
          round
          class="ai-button"
          color="#CC8751"
          @click="handleAIIdentify"
          :loading="loading_bt"
          v-show="showBtn"
      >
        AI识别
      </van-button>
    </div>

    <div class="upload-content" v-show="showUploadContent">
      <!-- 提问部分 -->
      <div class="section question-section">
        <div class="section-header">
          <div class="label">提问：</div>
          <div class="action orange" @click="handleAIIdentify">重新提问</div>
        </div>

        <!-- Loading overlay that only covers this section -->
        <van-loading
            v-if="loading_question"
            type="spinner"
            class="question-loading"
            vertical
        >正在识别中...</van-loading>

        <van-field
            v-model="question"
            type="textarea"
            class="textarea-box"
            :autosize="{ maxHeight: 200 }"
            :disabled="loading_question"
        />
      </div>

      <!-- 解读部分 -->
      <div class="section" style="margin-top: 0.6rem">
        <div class="bind-opr">
          <div class="action orange" @click="showBind = true;setempty=true">{{ customername ? '修改患者' : '绑定患者' }}</div>
          <div class="orange" v-show="customername" style="margin-left: 0.1rem;margin-top: 0.03rem" @click="cancelBind(data.docId)">取消绑定</div>
        </div>
        <div class="section-header">
          <div class="label">解读：</div>
          <div style="display: flex;  gap:0.1rem;">
            <div v-show="customername" style="color: #999995;margin:0.03rem 0.1rem 0 0;font-size: 0.4rem">
              绑定患者（{{customername}}）
            </div>

          </div>
        </div>

        <!-- Interpretation box with loading overlay -->
        <div class="interpret-box-wrapper">
          <van-loading
              v-if="loading_answer"
              type="spinner"
              class="interpret-loading"
              vertical
          >解读中...</van-loading>

          <div class="interpret-box" :class="{ 'loading-content': loading_answer }">
            <div class="text">{{ interpretation }}</div>

            <div class="bottom-link">
              希望以上解读对您有帮助！
            </div>

            <div>
              <div v-if="feedbackSubmitted" class="feedback-message">
                反馈成功，反馈结果为：<span :style="{ color: feedbackColor }">{{feedbackMsg}}</span>
              </div>
              <div v-else class="feedback-box">
                <button class="bad-btn" @click="feedbackResult('2')">解读不对</button>
                <button class="good-btn" @click="feedbackResult('1')">解读准确</button>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
    <div style="height:0.5rem;"></div>


    <van-dialog v-model="showBind" @confirm="confirm">
      <van-sticky :offset-top="0">
        <div class="dialog_title">
          <div>选择患者</div>

        </div>
        <van-icon class="close_icon" name="cross"  @click="()=>{showBind=false;setempty = false}"  />
      </van-sticky>
      <div>
        <patientList v-if="setempty" @patientData="patientFromChild" :offset="41" :p_clinicid="clinicid" :noButton="true"/>
      </div>
    </van-dialog>
  </div>
</template>
<script>
// import { wxappointmentplandetail, wxjsapiauth, wxconfirmappointment } from '@/api/medical'
import { mapGetters } from 'vuex'
// import patientList from '../patientList/index.vue'
import {ImagePreview, Lazyload} from 'vant';
import Vue from 'vue';
import errorImg from '@/assets/医生头像.png'
import {Toast} from "vant";
import {
  aicancelbind,
  aiidentifymsg,
  airesultfeedback,
  getaiquestion,
  submitaiquestion,
  wxaibindusers,
  wxdeleteattach
} from "@/api/medical";
import axios from "axios";
import patientList from "@/view/patientList/index.vue";
Vue.use(Lazyload, {
        lazyComponent: true,
        loading: "https://yz.iyzzy.com/icon/loading.gif",
        error: errorImg
    });
export default {
    components: {patientList},
    computed: {
        ...mapGetters([
            'username', 'clinicid', 'openid'
        ])
    },
    data() {
        return {
          questionId:'',
          data: {},
          fileList: [],
          loading_bt: false,
          uploadUrl:process.env.VUE_APP_UPLOAD_URL,
          question:'',
          interpretation: "",
          showBtn: true,
          showUploadContent: false,
          loading_question: false,
          loading_answer: false,
          showBind: false,
          setempty: true,
          customername: '',
          customerid: '',
          userid: '',
          checked:0,
          p_customername: '',
          p_customerid: '',
          p_userid: '',
          p_checked:0,
          feedbackSubmitted: false,
          feedbackMsg :'',
          feedbackColor:'',
          attachId:''
        }
    },
    created() {
      this.$store.dispatch('hideOrShowNav', false)
      this.questionId = this.$route.query.questionid || ''
      console.log("questionId,",this.questionId)
      this.getUploadMsg();
    },

    methods: {
      getUploadMsg() {
        console.log("lastAttachmentId:",this.$store.state.aiIdentify.lastAttachmentId)
        let data = {
          questionid:this.questionId,
          attachid: this.$store.state.aiIdentify.lastAttachmentId
        }
        aiidentifymsg(data).then(response =>{
          if (Toast) {
            Toast.clear();
          }
          this.data = response.response_body
          console.log("data",this.data)
          this.userid = this.data.userId
          this.customername = this.data.username
          this.customerid = this.data.customerId
          this.question = this.data.question
          this.interpretation = this.data.answer
          if (this.question){
            this.showBtn = false; //隐藏按钮
            this.showUploadContent = true; //打开解答框
            this.loading_question = false;
            this.loading_answer = false;
          }

          if (this.data.accuracy && this.data.accuracy !== 0)
          this.feedbackSubmitted = true;
          if (this.data.accuracy === 1){
            this.feedbackMsg = '解读准确'
            this.feedbackColor = '#4EAE04';
          }
          if (this.data.accuracy === 2){
            this.feedbackMsg = '解读不对'
            this.feedbackColor = 'red';
          }
          this.attachId = this.data.attachId
        })
      },
      onAfterRead(file,detail) {
        file.status = 'uploading';
        file.message = '上传中...';
        let formData = new FormData()
        formData.append('file', file.file)


        // formData.append('docNum', this.fileType)
        // formData.append('docId', this.docId)
        const instance = axios.create({
          withCredentials: true
        })
        let config = {
          headers: {
            'Content-Type': 'application/octet-stream',
          }
        }

        let url = this.uploadUrl + "?docNum=" + '1002' + "&userId=" +this.data.userId + "&docId=" + this.data.docId

        instance.post(url, formData, config).then((response) => {
          console.log(response, '---upload response')
          if (response.data) {
            if (response.data.error == '0') {
              file.attachId = response.data.attchId
              file.status = 'done';
              Toast.success('图片上传成功');
            } else {
              Toast.fail('图片上传异常');
              this.fileList.splice(detail.index, 1)
            }
          } else {
            Toast.fail('图片上传异常');
            this.fileList.splice(detail.index, 1)
          }

        }).catch(() => {
          Toast.fail('图片上传失败');
          this.fileList.splice(detail.index, 1)
        })
      },

      onOversize() {
        Toast.fail('图片大小不能超过20M');
      },

      beforeDelete(file, detail) {
        let vm = this;
        this.$dialog.confirm({
          title: null,
          message: "是否删除该图片",
        })
            .then(() => {
              return new Promise((resolve, reject) => {
                if (this.loading_answer == true) {
                  Toast.fail('正在识别，不允许删除图片')
                  return;
                }
                Toast.loading({
                  message: '正在删除图片...',
                  forbidClick: true,
                })
                let data = {
                  username: this.username,
                  attachid: file.attachId
                }
                wxdeleteattach(data).then(() => {
                  Toast.clear()
                  console.log(detail.index);
                  vm.fileList.splice(detail.index, 1)
                  this.controlBtn();
                  this.question = '';
                  this.interpretation = '';
                  Toast.success('图片删除成功');
                })
                resolve()
              })
            })
            .catch(() => {
              // Toast.success('取消图片删除');
              return false
            });
      },

      //ai识别
      async handleAIIdentify() {
        if (!this.questionId && !this.fileList.length > 0) {
          Toast.fail('请上传图片');
          return;
        }
        this.loading_bt = true
        this.loading_answer = true;
        this.loading_question = true;

        let attachId = this.fileList[0]?.attachId ? this.fileList[0].attachId : this.attachId;
        let sub_data = {
          type: '3',
          question: this.question,
          username: this.username,
          attachId: attachId,
        }
        console.log("sub_data",sub_data)

        //获取问题
        getaiquestion(sub_data).then(resp => {
          this.showUploadContent = true; //打开解答框
          this.interpretation = ''; //初始化答案
          let data = resp.response_body;
          if (data.flag){
            if (data.isResult && data.aiQuestion){
              this.loading_question = false;
              this.question = data.aiQuestion;
              this.loading_bt = false
              this.showBtn = false; //隐藏按钮

              //请求解答接口
              let req_data = {
                type: '3',
                question: data.aiQuestion,
                username: this.username,
                attachId: attachId,
              }
              // 提交问题
              submitaiquestion(req_data).then(resp2 => {
                let data2 = resp2.response_body;
                if (data2.flag){
                  this.loading_question = false;
                  this.loading_answer = false;
                  this.interpretation = data2.aiAnswer;
                  this.$store.commit('aiIdentify/SET_LAST_ATTACHMENT_ID', attachId);
                  console.log("lastAttachmentId:",this.$store.state.aiIdentify.lastAttachmentId)
                }else {
                  this.controlBtn();
                  Toast.fail('系统异常，请稍后再试');
                }
              }).catch(() => {
                this.controlBtn();
                Toast.fail('系统异常，请稍后再试');
              })
            }else {
              this.controlBtn();
              Toast.fail('该报告单非检验报告单，无法识别');
            }
          }else {
            this.controlBtn();
            Toast.fail('系统异常，请稍后再试');
          }

        }).catch(() => {
          this.controlBtn();
          Toast.fail('系统异常，请稍后再试');
        });
      },

      // 页面控制
      controlBtn(){
        this.loading_bt = false;
        this.showBtn = true;
        this.loading_question = false;
        this.loading_answer = false
        this.showUploadContent = false;
      },

      //绑定患者
      patientFromChild(data) {
        this.p_customerid = data.customerid
        this.p_customername = data.customername
        this.p_userid = data.userid
        this.p_checked = data.checked
      },

      //绑定患者确定
      confirm(){
        if (this.customername){
          this.$dialog.confirm({
            title: null,
            message: "是否绑定患者为："+this.p_customername+"？",
          }).then(() => {
            this.bindUsers()
          }).catch(() => {
            return false
          });
        }else{
          this.bindUsers()
        }
      },

      bindUsers(){
        this.setempty = true
        this.customerid = this.p_customerid;
        this.customername = this.p_customername;
        this.userid = this.p_userid;
        this.checked = this.p_checked

        //调用绑定接口
        let req_data = {
          openId: this.openid,
          userId: this.userid,
          customerId: this.customerid,
          docId: this.data.docId,
        }
        wxaibindusers(req_data).then(resp => {
          let data = resp.response_head;
          if (data.retinfo.retcode === '0'){
            Toast.success('绑定成功')
          }else {
            Toast.fail('绑定失败，请稍后再试');
          }
        }).catch(() => {
          Toast.fail('系统异常，请稍后再试');
        })
      },

      feedbackResult(isAccuracy){
        let attachId = this.fileList[0]?.attachId ? this.fileList[0].attachId : this.attachId;

        let req_data = {
          isAccuracy: isAccuracy,
          attachId: attachId,
          type: '3'
        }

        airesultfeedback(req_data).then(resp => {
          let data = resp.response_body;
          if (data.flag){
            Toast.success('反馈成功');

            this.feedbackSubmitted = true;
            if (isAccuracy === '1'){
              this.feedbackMsg = '解读准确'
              this.feedbackColor = '#4EAE04';
            }
            if (isAccuracy === '2'){
              this.feedbackMsg = '解读不对'
              this.feedbackColor = 'red';
            }
          }else {
            Toast.fail(data.msg);
          }
        }).catch(() => {
          Toast.fail('系统异常，请稍后再试');
        })
      },
      jumpHistory(){
        //识别中则不允许跳转
        if (this.loading_answer){
          return;
        }
        this.$router.push({path:'/aiHistory'})
      },
      // 预览文件图片
      sceneImg(image) {
        let images =[]
        images.push(image)
        ImagePreview({
          images: images,       // 需要预览的图片 URL 数组
          showIndex: true,      // 是否显示页码
          loop: false,          // 是否开启循环播放
          closeable: true,      // 是否在页面回退时自动关闭
          startPosition: 0  // 图片预览起始位置索引
        })
      },
      cancelBind(docId){
        this.$dialog.confirm({
          title: null,
          message: "是否解绑患者【"+this.customername+"】？",
        }).then(() => {
          let req_data = {
            docId: docId,
          }

          aicancelbind(req_data).then(resp => {
            let data = resp.response_body;
            if (data.flag){
              Toast.success('解绑成功')
              //数据还原
              this.customerid = '';
              this.p_customerid = ''
              this.customername = '';
              this.p_customername = '';
              this.userid = '';
              this.checked = '';
              this.p_checked = '';
              this.p_userid = '';
            }else{
              Toast.fail(data.message);
            }
          }).catch(() => {
            Toast.fail('系统异常，请稍后再试');
          })
        }).catch(() => {
          return false
        });
      },
    },
}

</script>
<style lang="scss" scoped>
.container {
  padding: 0.43rem; /* 16px */
  background-color: #F6F6F4;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-weight: bold;
  font-size: 0.43rem; /* 16px */
}

.history {
  color: #f57c00;
  font-size: 0.37rem; /* 14px */
  cursor: pointer;
}

.sub-title {
  font-size: 0.35rem; /* 13px */
  color: #888;
  margin: 0.21rem 0 0.32rem; /* 8px 0 12px */
}

.upload-box {
  background: #F5F5F5;
  border-radius: 0.32rem;
  height: 8rem;
  width: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.3rem;
  overflow: hidden;
}

.ai-button {
  font-weight: bold;
  font-size: 0.43rem; /* 16px */
}

.img_box {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.upload-content{
  background: #fff;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 0.32rem;
}
.upload-icon{
  font-size: 3rem;
  color: #ddd;
}


.section {
  background-color: #fff;
  border-radius: 0.32rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.32rem;
}

.label {
  font-weight: bold;
  font-size: 0.43rem;
}

.action {
  font-size: 0.4rem;
  cursor: pointer;
  margin-top: 0.03rem;
}

.orange {
  color: #f57c00;
}

.textarea-box {
  background-color: #f5f5f5;
  border-radius: 0.2rem;
  font-size: 0.4rem;
  white-space: pre-wrap;
}

.interpret-box {
  font-size: 0.4rem;
  color: #333;
  line-height: 1.6;
}

.bottom-link {
  font-size: 0.4rem;
  color: #3e80f5;
  margin-top: 0.32rem;
  cursor: pointer;
}
.text{
  white-space: pre-wrap;  /* 关键点：保留 \n 并自动换行 */
  word-break: break-word;
  font-size: 0.4rem;
  line-height: 1.6;
}

.section.question-section {
  position: relative; /* Needed for absolute positioning of loading overlay */
}
.question-loading {
  position: absolute;
  top: 40px; /* Below the section header */
  left: 0;
  width: 100%;
  height: calc(100% - 40px); /* Full height minus header */
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.textarea-box[disabled] {
  background-color: #f5f5f5;
}

.interpret-box-wrapper {
  position: relative;
}

.interpret-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.loading-content {
  filter: blur(1px);
  opacity: 0.7;
}

.close_icon{
  color: #969799;
  position: absolute !important;
  top: 11px;
  right: 13px;
  font-size: 20px;
}

:deep .van-dialog__content {
  max-height: 450px;
  overflow: auto;
}

:deep .van-dialog {
  width: 90%;
}

:deep .left {
  width: unset !important;
  display: flex;
}

:deep .right {
  width: unset !important;
}

:deep .treat_main_list {
  width: 100%;

  .van-radio {
    overflow: visible;

  }
}

:deep .van-radio {
  display: flex;
}

:deep .btnimg {
  display: none;
}

:deep .detail_info {
  display: none !important;
}

:deep .van-dialog__header {
  padding: 10px 0px !important;
}

:deep .van-cell {
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .van-icon {
  height: unset !important;
}

:deep .van-radio__icon {
  height: 1.1rem;
}
//:deep .van-button--round{
//  background-color: #CF8C57;
//  width: 150px;
//  height: 38px;
//  text-align: center;
//  line-height: 38px;
//  color: #fff;border-radius: 21px;
//}
.dialog_title{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 10px 10px;
}

.feedback-box {
  display: flex; /* 使用flex布局 */
  gap: 0.8rem;
  margin-top: 0.8rem;
}

.bad-btn {
  flex: 1; /* 占据剩余空间的一半 */
  padding: 10px 20px;
  background-color: #ccc; /* 灰色背景 */
  border: none;
  color: #333;
  cursor: pointer;
  font-size: 16px;
  border-radius: 10px;
}

.good-btn {
  flex: 1; /* 占据剩余空间的一半 */
  padding: 10px 20px;
  background-color: #CF8C57; /* 黄色背景 */
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  border-radius: 10px;
}
.feedback-message{
  color: #999
}

.disabled-style {
  cursor: not-allowed;
  color: #ccc !important; /* 灰色 */
  opacity: 0.7;
}
.bind-opr{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
